import { Component } from '@angular/core';


@Component({
  selector: 'ff-mfa-rejected',
  templateUrl: './mfa_rejected.component.html',
  styleUrls: ['./mfa_rejected.component.scss'],
})
export class MfaRejectedComponent {

  constructor(

  ) {}
}
